<template>

        <div class="env-element col s6 m6 l4 xl12"
             v-if="env.show_in_category"
             :class="[ typeX ? 'largxl6' : 'xl12' ]"
        >
            <div class="env-img"
                 v-if="env.icon"
            >
                <img
                    :src="env.icon"
                />
            </div>
            <div class="env-button"
                 v-if="env.show_in_category"
                 :class="{ active: el.isActive }"
                 v-on:click="clickElement(env.id)"
            >
                <!--v-on:click="onChange()"-->
                {{env.title}}
            </div>
        </div>
        <div class="env-element icon col s6 m6 l12 xl12"
             v-else-if="!env.show_in_category && env.icon"
             :class="[type.column2x ? 'largxl6' : 'xl12']"
        >
            <div class="env-img"
            >
                <img
                    :src="env.icon"
                />
            </div>
        </div>

</template>


<script>
    export default {
        name: 'EnvBlockLand',
        props: ['selectEnvironments', 'type', 'env'],
        data() {
            return {
                el: {
                    id: this.env.id,
                    isActive: false
                },
            }
        },
        computed: {
            typeX: function () {
                return this.type.column2x;
            }
        },
        watch:{
            'selectEnvironments'(){
                if (this.selectEnvironments.indexOf(this.el.id) != -1) {
                    this.el.isActive = true
                }else{
                    this.el.isActive = false
                }
            }
        },
        mounted() {
            if (this.selectEnvironments.indexOf(this.el.id) != -1) {
                this.el.isActive = true
            }else{
                this.el.isActive = false
            }
        },
        methods: {
            clickElement(elem_id){
                this.$emit('setActiveEnv', elem_id)
                this.$router.push({ name: 'Environments' });
            },
            onChange() {
                this.el.isActive = !this.el.isActive;
                this.$emit('addEnv', this.el)
            }
        }
    }
</script>